import { Component, OnInit, ViewEncapsulation, OnDestroy, Input, ViewChild } from '@angular/core';
import { ScheduleDate, Dictionary, SavingParameters, ContributionSubTypesEnum, ContributionTypesEnum, Contribution, SavingScheduleDate, FinancialReturn, Loan, Withdraw, Parameter, Employee, PeriodTypeEnum, PayrollParameters, LoanParameters } from '@akiba/models_bimbo';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { MatDialog, MatTable } from '@angular/material';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { take } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { MatSelectChange } from '@angular/material';

@Component({
  selector: 'app-ps-statement',
  templateUrl: './ps-statement.component.html',
  styleUrls: ['./ps-statement.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PsStatementComponent implements OnInit, OnDestroy {

  @ViewChild('scheduleDatesTable', { static: false }) scheduleDatesTable: MatTable<any>;
  displayedColumns = ['displayDate', 'totalContribution', 'totalExtrasContribution', 'totalWithdrawals', 'total'];
  selectedYearData: any;
  availableYears: Array<string>;
  selectedYearTotal = 0;
  selectedYearTotalExtras = 0;
  selectedYearTotalWithdrawals = 0;
  groupScheduleDatesForDisplay: Array<any> = new Array<any>();

  scheduleDates: Dictionary<ScheduleDate>;

  //////////////////////////////////////
  payrollParameter: PayrollParameters | null = null;
  permanentSavingParameter: Parameter | null = null;
  //////////////////////////////////////
  currentEmployee: Employee;
  //////////////////////////////////////

  // tslint:disable-next-line: variable-name
  _permanentSavingsTotal = 0;
  // tslint:disable-next-line: variable-name
  _permanentSavingsExtrasTotal = 0;
  // tslint:disable-next-line: variable-name
  _permanentSavingsWithdrawalsTotal = 0;
  // tslint:disable-next-line: variable-name
  _permanentSavingsEmployeeTotal = 0;
  // tslint:disable-next-line: variable-name
  _suraAmount = 0;
  _suraAmountCurrent = 0;
  complementoCurrentYear = 0 ;
  complementoCurrentPast = 0;
  complementoSettlementPast = 0;
  totalPastYears = 0;

  pastYearsData: any = {
    text: 'Saldo Años Anteriores:',
    totalContribution: 0,
    totalExtrasContribution: 0,
    totalWithdrawals: 0,
    subTotal: 0,
    total: 0
  };

  totals: Array<any> = new Array<any>();
  totalCurrent : Array<any> = new Array<any>();
  totalPrevious : Array<any> = new Array<any>();
  totalLoan : Array<any> = new Array<any>();
  totalSettlement : Array<any> = new Array<any>();

  loansEmployee: Array<any> = Array<any>();
  loanAmountListPending: number = 0;
  firstDate = new Date();
  pastYears = Array<any>();
  selectedYear = this.firstDate.getFullYear();
  currentYear = this.firstDate.getFullYear();
  contributionSuraRT : Array<Contribution>;
  contributionSuraPastRT : Array<Contribution>;

  appLogicSubs: Subscription;
  @Input() contentLocation: AppState;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));

  constructor(
    private logicService: LogicService,
    public dialog: MatDialog,
    private dataService: DataSourceService,
    private breakpointObserver: BreakpointObserver
  ) {

    const parameters = this.logicService.dataManager.parameterDataLoader.parameters ? this.logicService.dataManager.parameterDataLoader.parameters : [];
    const payrollParameters = this.logicService.dataManager.parameterDataLoader.payrolls ? this.logicService.dataManager.parameterDataLoader.payrolls : [];


    this.currentEmployee = this.logicService.dataManager.proxyDataLoader.employee ? this.logicService.dataManager.proxyDataLoader.employee : this.logicService.dataManager.principalDataLoader.employee;
    this.permanentSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.permanentSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));
    this.payrollParameter = payrollParameters.find(e => e.payrollAppliesTo(this.currentEmployee));

  }

  ngOnInit() {

    this.groupScheduleDatesForDisplay = new Array<any>();
    if (!this.currentEmployee.permanentSavings) {

      this._permanentSavingsEmployeeTotal = 0;
      this._permanentSavingsExtrasTotal = 0;
      this._permanentSavingsWithdrawalsTotal = 0;
      this._permanentSavingsTotal = 0;

    } else {

      const dates = this.payrollParameter ? this.payrollParameter.payrollDates : new Array<ScheduleDate>();
      dates.forEach(sd => {
        if (!sd.scheduleDateID) {
          sd.scheduleDateID = sd.startDate.getTime().toString();
        }
      });

      this.currentEmployee.permanentSavings.addApplicablePayrollDaysForDisplay(dates);
      
      this.rendimiento().then(() => {
        this.generateTotales();
      });
    }

  }


  selectedPeriodChange(event: MatSelectChange) {

    if (!event.value) {
      let dateYear = new Date();
      this.selectedYear = dateYear.getFullYear();
    } else {
      
    this.complementoCurrentPast = 0;
    this.complementoCurrentYear = 0;
      this.groupScheduleDatesForDisplay = new Array<any>();
      this.selectedYear = event.value;
      this.rendimiento().then(() => {
        this.generateTotales();
      });


    }

  }

  /**
   * funcion para regresar el prestamo activo en colaboradores en lista de espera
   */
  async loanActiveInListPending() {
    const loans = await this.dataService.loadLoanActiveListPending(this.currentEmployee.workInformation.employeeNumber, 500, 500);
    let restructuredID: string = '';
    let loanFalse = [];
    let activePending: boolean;
    let arrayActive: Array<any> = [];
    let sumaPaids: number = 0;
    let interes: number = 0;
    let loan: number = 0;
    let interestPercentage: number = 0;
    let activePendingList: Array<any> = [];
    activePendingList = loans.filter(e => e.active === true && e.type === 'permanent' && (e.status == 'active_pending' || e.status == 'review'));


    if (loans.length > 1 && activePendingList.length > 0) {
      const loanListPending = loans.filter(e => e.active === true && e.type === 'permanent' && (e.status === 'active_pending' || e.status === 'review'));

      if (loanListPending.length > 0) {
        loanListPending.map(e => restructuredID = e.restructuredID);
      }
    }


    if (restructuredID != '') {
      const loadLoan: any = await this.dataService.loadLoan(restructuredID).pipe(take(1)).toPromise().catch(error => {
        console.log(error);
        return [];
      });
      /*** loadLoan.status == 'restructured' */
      if (loadLoan.status != 'paid' && loadLoan.status != 'withdraw') {
        const cretedAt = loadLoan.createdAt.toDate();
        const interestType = loadLoan.interestType;
        loan = loadLoan.requestedNumberOfPayments;
        interestPercentage = loadLoan.interestPercentage;
        const suma = await this.dataService.loanActiveInPendingList(this.currentEmployee.workInformation.employeeNumber, cretedAt, interestType);
        suma.map(e => {
          sumaPaids = loadLoan.requestedAmount - e.sumPayments;
          loan = loadLoan.requestedNumberOfPayments - e.longPayments - 1
        });
      }
    }

    interes = loan * sumaPaids * interestPercentage;


    return sumaPaids;
  }


  async rendimiento() {
    let timeYearFrom = new Date(this.selectedYear + '-01-01').getTime();
    let timeYearTo = new Date(this.selectedYear + 1 + '-01-01').getTime();

    let contributionSuraArray: Array<FinancialReturn>;
    let suraRetirement = 0 ;

    const c2 = await this.dataService.loadEmployeeContributions(ContributionSubTypesEnum.CAL_SURA, this.currentEmployee.workInformation.employeeNumber, timeYearFrom, timeYearTo).pipe(take(1)).toPromise().catch(error => {
      console.log(error);
      return [];
    });

    const suraEY = await this.dataService.loadEmployeeContributions('CAL_SURAEY', this.currentEmployee.workInformation.employeeNumber, timeYearFrom, timeYearTo).pipe(take(1)).toPromise().catch(error => {
      console.log(error);
      return [];
    }); 

    
    // year 
    if ( this.selectedYear === this.currentYear){
      contributionSuraArray  = c2.map((rec: any) => new FinancialReturn(rec));
    }else {
      contributionSuraArray  = suraEY.map((rec: any) => new FinancialReturn(rec)).filter(e => e.regDate.getFullYear() === this.selectedYear);
      const contributionRT = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => e.subType.includes('_SURART') && e.regDate.getFullYear() === this.selectedYear);
      suraRetirement = contributionRT.length > 0 ?  contributionRT.map(x => x.investmentReturn).reduce((p, n) => p + n, 0) : 0;

      
    }

// para sura años anter
    this._suraAmount = contributionSuraArray.map(x => x.amount).reduce((p, n) => p + n, 0);    
    this.loanAmountListPending = await this.loanActiveInListPending();

  }


  async generateTotales() {
    const timeCurrent = new Date(this.selectedYear + '-01-01').getTime();
    let timeYearTo = new Date(this.selectedYear + 1 + '-01-01').getTime();
    let contributionSuraCurret: Array<FinancialReturn>;
    this.contributionSuraRT = null;
    this.contributionSuraPastRT = null;

    // contribution current year 

    const contributionCurrentYear: Array<Contribution> = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => (e.subType === ContributionSubTypesEnum.CAL_DR || e.subType === ContributionSubTypesEnum.CAL_DRE) && e.regDate.getFullYear() === this.selectedYear);
    const minusCurrentYear: Array<Contribution> = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => (e.subType !== ContributionSubTypesEnum.CAL_DR && e.subType !== ContributionSubTypesEnum.CAL_DRE) && e.regDate.getFullYear() === this.selectedYear);

    const contributionPast: Array<Contribution> = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => (e.subType === ContributionSubTypesEnum.CAL_DR || e.subType === ContributionSubTypesEnum.CAL_DRE) && e.regDate.getFullYear() < this.selectedYear);
    const minusCurrentPast: Array<Contribution> = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => (e.subType !== ContributionSubTypesEnum.CAL_DR && e.subType !== ContributionSubTypesEnum.CAL_DRE) && e.regDate.getFullYear() < this.selectedYear);

    const minusAL: Array<Contribution> = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => e.subType.includes('_AL'));
    const totalCurrentYear = minusCurrentYear.map(r => r.investmentReturn + r.loanPerformance).reduce((p, n) => p + n, 0);
    const totalCurrentYearInvestment = minusCurrentYear.map(r => r.investmentReturn).reduce((p, n) => p + n, 0);
    const totalCurrentPast = minusCurrentPast.map(r => r.investmentReturn + r.loanPerformance).reduce((p, n) => p + n, 0);
    const totalCurrentPastInvestment = minusCurrentPast.map(r => r.investmentReturn).reduce((p, n) => p + n, 0);

    const resultCurrentPast = contributionPast.map(x => x.investmentReturn).reduce((p, n) => p + n, 0);
    const resultCurrentYear = contributionCurrentYear.map(x => x.investmentReturn).reduce((p, n) => p + n, 0);
    this.contributionSuraRT = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => e.subType.includes('_SURART') && e.regDate.getFullYear() === this.selectedYear);
    const suraAmountRT = this.contributionSuraRT.length > 0 ? this.contributionSuraRT.map(x => x.investmentReturn).reduce((p, n) => p + n, 0) : 0;

    const currentSura = await this.dataService.loadEmployeeContributions(ContributionSubTypesEnum.CAL_SURA, this.currentEmployee.workInformation.employeeNumber, timeCurrent, timeYearTo).pipe(take(1)).toPromise().catch(error => {
      console.log(error);
      return [];
    });

    /** subType SURAEY, SURART, SURARL */
    const pastSura = await this.dataService.loadEmployeeContributions('CAL_SURAEY', this.currentEmployee.workInformation.employeeNumber).pipe(take(1)).toPromise().catch(error => {
      console.log(error);
      return [];
    });

    /** si el año seleccionado es el año actual o no */
    if (this.selectedYear == this.currentYear) {
      contributionSuraCurret = currentSura.map((rec: any) => new FinancialReturn(rec));
    } else {
      contributionSuraCurret = pastSura.map((rec: any) => new FinancialReturn(rec)).filter(e => e.regDate.getFullYear() === this.selectedYear);
    }

    this._suraAmountCurrent = contributionSuraCurret.map(x => x.amount).reduce((p, n) => p + n, 0);

    const contributionSuraPastEY: Array<FinancialReturn> = pastSura.map((rec: any) => new FinancialReturn(rec)).filter(e => e.regDate.getFullYear() < this.selectedYear);
    const suraPastEY: Array<FinancialReturn> = pastSura.map((rec: any) => new FinancialReturn(rec)).filter(e => e.regDate.getFullYear() == (this.selectedYear - 1));

    this.contributionSuraPastRT = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => e.subType.includes('_SURART') && e.regDate.getFullYear() < this.selectedYear);

    const contributionSuraPastRL = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => e.subType.includes('_SURARL') && e.regDate.getFullYear() <= this.selectedYear);

    const suraAmountPastEY = contributionSuraPastEY.map(x => x.amount).reduce((p, n) => p + n, 0);
    const amountPastEY = suraPastEY.map(x => x.amount).reduce((p, n) => p + n, 0);

    const suraAmountPastRT = this.contributionSuraPastRT.length > 0 ? this.contributionSuraPastRT.map(x => x.investmentReturn).reduce((p, n) => p + n, 0) : 0;
    const suraAmountPastRL = contributionSuraPastRL.length > 0 ? contributionSuraPastRL.map(x => x.investmentReturn).reduce((p, n) => p + n, 0) : 0;

    this.complementoSettlementPast = suraAmountPastRL;
    this.complementoCurrentYear = resultCurrentYear + this._suraAmountCurrent + suraAmountRT - amountPastEY;
    this.complementoCurrentPast = resultCurrentPast + amountPastEY + suraAmountPastRT;
    this.generateYearTotals();
  }

  generateYearTotals() {

    this._permanentSavingsEmployeeTotal = 0;
    this._permanentSavingsExtrasTotal = 0;
    this._permanentSavingsWithdrawalsTotal = 0;
    this._permanentSavingsTotal = 0;
    this.selectedYearTotal = 0;
    this.selectedYearTotalExtras = 0;
    this.selectedYearTotalWithdrawals = 0;
    this.totals = new Array<any>();
    this.totalCurrent  = new Array<any>();
    this.totalPrevious  = new Array<any>();
    this.totalLoan = new Array<any>();
    this.totalSettlement  = new Array<any>();

    const currentY = this.selectedYear.toString();
    let years = Array<any>();
    let arrayOfValues = [];


    // para cada año  
    const contributionArrayF: Array<Contribution> = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => (e.subType === ContributionSubTypesEnum.CAL_DR || e.subType === ContributionSubTypesEnum.CAL_DRE) && e.regDate.getFullYear() <= this.selectedYear);
    const minus1: Array<Contribution> = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => (e.subType !== ContributionSubTypesEnum.CAL_DR && e.subType !== ContributionSubTypesEnum.CAL_DRE ) && e.regDate.getFullYear() <= this.selectedYear);
    //const minusAL :Array<Contribution> = this.currentEmployee.permanentSavingsData.map((rec: any) => new Contribution(rec)).filter(e => e.subType.includes('_AL') || e.subType.includes('_N')).filter(e => e.employeeSettlement > 0);

    const t1 = minus1.map(r => r.investmentReturn + r.loanPerformance).reduce((p, n) => p + n, 0);
    const t1Settlement = t1 + this.complementoSettlementPast;

    //const t11 = minus1.map(r => r.investmentReturn).reduce((p, n) => p + n, 0);

   //por validar si se ocupara o no 
    // const totalAL = minusAL.map(r => Math.abs(r.employeeSettlement)).reduce((p, n) => p + n, 0);
    const result = contributionArrayF.map(x => x.investmentReturn).reduce((p, n) => p + n, 0);
    const complementoSura = result + t1  + this._suraAmount;

    

    const obj = this.currentEmployee.permanentSavings.groupedScheduleDatesForDisplay();
    const keys = Object.keys(obj);
    keys.sort();

    for (const i of keys) {

      if (parseInt(i) > 2020 && parseInt(i) <= this.currentYear) {

        years.push(parseInt(i));
      }
    }
    const dataArr = new Set(years);
    this.pastYears = Array.from(dataArr);

    if (obj.hasOwnProperty(currentY)) {

      this.groupScheduleDatesForDisplay = this.groupScheduleDatesForDisplay.concat(obj[currentY]);
    }


    for (const i of keys) {

      if (i < currentY) {
        const anArray = obj[i];
        arrayOfValues = arrayOfValues.concat(anArray);
      }
    }

    if (arrayOfValues.length) {
      this._permanentSavingsEmployeeTotal = arrayOfValues.map(element => element.totalContribution).reduce(((prev, next) => prev + next), 0);
      this._permanentSavingsExtrasTotal = arrayOfValues.map(element => element.totalExtrasContribution).reduce(((prev, next) => prev + next), 0);
      this._permanentSavingsWithdrawalsTotal = arrayOfValues.map(element => element.totalWithdrawals).reduce(((prev, next) => prev + next), 0);
    }
    this._permanentSavingsTotal = (this._permanentSavingsEmployeeTotal + this._permanentSavingsExtrasTotal) - this._permanentSavingsWithdrawalsTotal;


    this.pastYearsData = {
      text: 'Saldo Años Anteriores:',
      totalContribution: this._permanentSavingsEmployeeTotal,
      totalExtrasContribution: this._permanentSavingsExtrasTotal,
      totalWithdrawals: this._permanentSavingsWithdrawalsTotal,
      subTotal: this._permanentSavingsTotal,
      total: 0
    };

    this.groupScheduleDatesForDisplay.unshift(this.pastYearsData);
    let total = 0;
    this.groupScheduleDatesForDisplay.forEach(element => {
      total += element.subTotal;
      element.total = total;
      this.selectedYearTotal += element.totalContribution ;
      this.selectedYearTotalExtras  += element.totalExtrasContribution ;
      this.selectedYearTotalWithdrawals  += element.totalWithdrawals ;
    });
    this.groupScheduleDatesForDisplay.shift();

    this.selectedYearData = {yearTotal : this.selectedYearTotal - this._permanentSavingsEmployeeTotal, 
      yearTotalExtras: this.selectedYearTotalExtras -  this._permanentSavingsExtrasTotal, yearTotalWithdrawals : this.selectedYearTotalWithdrawals - this._permanentSavingsWithdrawalsTotal};
    const t2 = {
      text: 'Total Ahorrado Acumulado',
      total: (this.selectedYearTotal + this.selectedYearTotalExtras) -  this.selectedYearTotalWithdrawals
    };

    const t3 = {
      text: 'Total Rendimiento Acumulado',
      total: complementoSura < 0 ? 0 : complementoSura
    };

    const t23 = {
      text: 'Total Acumulado',
      total: t3.total + t2.total
    };

    
    if (this.loanAmountListPending > 0 &&  this.selectedYear == this.currentYear) {
      const t4 = {
        text: 'Saldo De Préstamo',
        total: this.loanAmountListPending
      };

      this.totalLoan.push(t4);
    }

    this.totals.push(t2);
    this.totals.push(t3);    
    this.totals.push(t23);

    /** total del año  */
    const t5 = {
      text: 'Total Ahorrado del Año',
      total: this.selectedYearData.yearTotal + this.selectedYearData.yearTotalExtras ,
      note: 'Total aportaciones de ahorro nómina y extraordinarias del año vigente o consultado'
    };

    const t51 = {
      text: 'Total Rendimiento del Año',
      total: this.complementoCurrentYear, 
      note: 'Total rendimiento del año vigente o consultado'
    };

    const tYear = {
      text: 'Total Neto del Año',
      total: t5.total + t51.total
    };

    this.totalCurrent.push(t5);
    this.totalCurrent.push(t51);
    this.totalCurrent.push(tYear);

    const t6 = {
      text: 'Total Ahorrado de Años Anteriores',
      total: this._permanentSavingsEmployeeTotal + this._permanentSavingsExtrasTotal,
      note: 'Total aportaciones de ahorro nómina y extraordinarias ahorro de años anteriores al consultado'
    };

    const t61 = {
      text: 'Total Rendimiento de Años Anteriores',
      total: this.complementoCurrentPast,
      note: 'Total rendimientos de años anteriores al consultado' 
    };

    const tPrev = {
      text: 'Total Neto de Años Anteriores',
      total: t6.total + t61.total
    };

  this.totalPrevious.push(t6);
  this.totalPrevious.push(t61);
  this.totalPrevious.push(tPrev);


  const t7 = {
    text: 'Retiro de Ahorro',
    total: this.selectedYearTotalWithdrawals, 
    note: 'Total ahorro retirado acumulado al año vigente o consultado'
  };

  const t71 = {
    text: 'Rendimiento Liquidado',
    total: Math.abs(t1Settlement),
    note: 'Total rendimiento liquidado acumulado al año vigente o consultado'
    
  };

  const tSettlement = {
    text: 'Monto Total Liquidado',
    total: t7.total + t71.total, 
    note: 'Total ahorro y rendimiento retirado acumulado al año vigente o consultado'
  };

this.totalSettlement.push(tSettlement);




    if (this.currentEmployee.permanentSavingsLoan && this.currentEmployee.permanentSavingsLoan.active === true && this.currentEmployee.permanentSavingsLoan.status === 'active'  &&  this.selectedYear == this.currentYear) {
      const loan = new Loan(this.currentEmployee.permanentSavingsLoan.toAny());
      loan.scheduleDates = this.currentEmployee.permanentSavingsLoan.scheduleDates;


      const pending = loan.scheduleDates.values().filter(element => !element.paid).map(element => element.capital).reduce(((prev, next) => next ? prev + next : prev), 0);
      
      const t4 = {
        text: 'Saldo De Préstamo',
        total: pending
      };
      this.totalLoan.push(t4);

      const t5 = {
        text: 'Total Neto',
        total: (t2.total + t3.total) - pending,
      };

      this.totalLoan.push(t5);

    } else if (this.loanAmountListPending > 0  &&  this.selectedYear == this.currentYear) {

      const t5 = {
        text: 'Total Neto',
        total: (t2.total + t3.total) - this.loanAmountListPending,
      };

      this.totalLoan.push(t5);

    }
  }
  //termina funcion 
  // 

  get permanentSavingsTotal(): number {
    return this._permanentSavingsTotal;
  }

  get permanentSavingsExtrasTotal(): number {
    return this._permanentSavingsExtrasTotal;
  }

  get permanentSavingsWithdrawalsTotal(): number {
    return this._permanentSavingsWithdrawalsTotal;
  }

  get permanentSavingsEmployeeTotal(): number {
    return this._permanentSavingsEmployeeTotal;
  }

  get downloadURLLink(): string | null {

    const asp = this.permanentSavingParameter;
    if (asp && asp.savingParameter) {
      return asp.savingParameter.downloadLink();
    }

    return null;

  }

  cancel(tabIndex: number, detailIndex: number | null) {
    this.contentLocation.tabIndex = tabIndex;
    this.contentLocation.detailIndex = detailIndex;
    this.contentLocation.contentIndex = 0;
  }

  ngOnDestroy(): void {

    if (this.appLogicSubs && !this.appLogicSubs.closed) {
      this.appLogicSubs.unsubscribe();
      this.appLogicSubs = null;
    }

  }

}
